// client/src/pages/Admin/ProjectManager/components/ProjectHeader.tsx
/**
 * PROJECT HEADER COMPONENT
 * 
 * Displays the page header with title, description, and action buttons.
 * 
 * @module ProjectManager/Components/ProjectHeader
 */

import React from 'react';
import { FolderOpen, RefreshCw, Plus } from 'lucide-react';

interface ProjectHeaderProps {
    onRefresh: () => void;
    onNewProject: () => void;
    projectsCount: number;
}

export const ProjectHeader: React.FC<ProjectHeaderProps> = ({
    onRefresh,
    onNewProject,
    projectsCount
}) => {
    return (
        <div className="manager-header">
            <div>
                <h2>
                    <span className="header-icon" aria-hidden="true"><FolderOpen size={18} /></span>
                    Projects
                    <span className="header-count">({projectsCount})</span>
                </h2>
                <p className="header-description">
                    Manage and track all your projects in one place
                </p>
            </div>
            <div className="header-actions">
                <button
                    className="btn-secondary"
                    onClick={onRefresh}
                    aria-label="Refresh projects"
                >
                    <RefreshCw size={16} />
                    Refresh
                </button>
                <button
                    className="btn-primary"
                    onClick={onNewProject}
                    aria-label="Create new project"
                >
                    <Plus size={16} />
                    New Project
                </button>
            </div>
        </div>
    );
};